import { serialize } from '@/@core/libs/serialize/util'
import Http from '@/services/httpJobs'

export const gigCategoriesList   = (params = '') => Http.get(`/admin/gigs/categories${serialize(params)}`)
export const gigCategoryByID     = (params = '') => Http.get(`/gigs/categories/${params}`)
export const gigCategoryCreate   = (params = '') => Http.post('/admin/gigs/categories', params)
export const gigCategoryUpdate   = (params = '') => Http.put(`/admin/gigs/categories/${params.id}`, params)
export const gigCategoryDestroy  = (params = '') => Http.delete(`/admin/gigs/categories/${params.id}`)
